import React, { memo, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useForm } from 'react-hook-form'
import ValidatedTextInput from '../../ValidatedTextInput'
import { registerNewUser } from '../../../api/users/users'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Button from '../../Button'
import logoPapunet from '../../../styles/icons/papunet-logo.png'
import './styles.scss'

const RegistrationView = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
  } = useForm()
  const navigate = useNavigate()
  const user = useSelector((state) => state.user)
  const [response, setResponse] = useState(null)

  useEffect(() => {
    if (user && !(user.error || user.anonymous)) {
      navigate('/')
    }
  }, [user])

  const onSubmit = async (data) => {
    setResponse(null)
    const email = data.email.trim().toLowerCase()
    const res = await registerNewUser(email)
    setResponse(res)
  }

  // const closeView = () => {
  //   setResponse(null)
  //   navigate('/')
  // }

  return (
    <div className="registration-view-container">
      <div className="login-form-content">
        <img
          src={logoPapunet}
          alt="Papunet logo"
          className="registration-view-logo"
        />
        <h1 className="registration-view-header">Rekisteröidy</h1>
        <p>
          Näillä tunnuksilla voit käyttää sekä{' '}
          <a
            href="https://papuri.papunet.net"
            target="_blank"
            rel="noopener noreferrer"
          >
            Papuria
          </a>
          , että{' '}
          <a
            href="https://kuvatyokalu.papunet.net"
            target="_blank"
            rel="noopener noreferrer"
          >
            Papunetin kuvatyökalua
          </a>
          .{' '}
        </p>
        <p>
          Anna sähköpostiosoite johon haluat tunnukset. Tunnuksia voi olla vain yksi
          per sähköpostiosoite. Jos olet unohtanut aikaisemman salasanasi, voit uusia
          sen klikkaamalla linkkiä kirjautumislomakkeen vierestä.
        </p>
        <p>
          Jos et saa aktivointilinkkiä sähköpostiisi, tarkista roskapostikansiosi.
        </p>
        <form className="flex-form" onSubmit={handleSubmit(onSubmit)}>
          <ValidatedTextInput
            label="Sähköpostiosoite"
            name="email"
            placeHolder="Kirjoita sähköpostiosoite..."
            onChange={() => clearErrors()}
            labelClassName="hidden-label"
            inputClassName="text-input-field"
            {...register('email', { required: true })}
          />
          <div className="validation-error-text">
            {errors.email &&
              errors.email.type === 'required' &&
              'Kirjoita sähköpostiosoite.'}
          </div>
          <p
            className={
              response && response.error
                ? 'backend-response-text red-text'
                : 'backend-response-text success-text'
            }
          >
            {response && response.message}
          </p>
          <div className="modal-button-container">
            <Button type="submit" className="dialogue-button select-button">
              <div className="icon-button-content">
                <FontAwesomeIcon icon="sign-out-alt" className="info-icon" />
                Rekisteröidy
              </div>
            </Button>
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              margin: '1em 0',
            }}
          >
            <a
              href="https://papunet.net/kayttoehdot-ja-selosteet/tietosuojaseloste-papunetin-kuvatyokalujen-kayttajat/"
              target="_blank"
              rel="noopener noreferrer"
              className="link-button"
              style={{ fontSize: '16px' }}
              tabIndex={0}
            >
              Tietosuojaseloste
            </a>
          </div>
        </form>
      </div>
    </div>
  )
}

export default memo(RegistrationView)
